module.exports = __webpack_public_path__ + "static/media/bookshelf.1cbd91ea.png";